const setPuntoVenta = (state, puntoVenta) => {
  state.puntoVenta = puntoVenta;
}




export default {
  setPuntoVenta
};



// WEBPACK FOOTER //
// ./src/store/modules/punto/mutations.js